import '../styles/components/Topbar.css';

function Topbar() {
  return (
    <div className="topbar">
      <span>📍 Gurugram, India — Factory: Bahadurgarh, Haryana — 124507</span>
      <div className="topbar-links">
        <a href="mailto:export@pharmchem.net">✉ export@pharmchem.net</a>
        <a href="tel:+919810820562">📞 +91 98108 20562</a>
        <a href="http://www.phrmchem.net" target="_blank" rel="noreferrer">🌐 phrmchem.net</a>
      </div>
    </div>
  );
}

export default Topbar;
